// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusWarnIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="M12.13 17.63v-2.25M12.13 13.13V6.38"
    />
  </svg>,
  "StatusWarn",
);
export default StatusWarnIcon;
